import { getSocket } from '@src/App';
import { store } from '@src/state/store';
import { clearGameDetails } from '@src/state/slices/slice_game';
import { clearTournamentDetails } from '@src/state/slices/slice_tournament';

export default async () => {
  try {
    store.dispatch(clearGameDetails());
    store.dispatch(clearTournamentDetails());
    // await 200 ms before asking server for new game details
    await new Promise((resolve) => setTimeout(resolve, 200));
    getSocket().emit('getGames');
  } catch (e) {
    console.log(e);
  }
};
